__turbopack_context__.v({
  "buttonWrapper": "wlQm2a_buttonWrapper",
  "container": "wlQm2a_container",
  "logo": "wlQm2a_logo",
  "trigger": "wlQm2a_trigger",
});
